import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Notification } from '../types';
import { formatDateTimeFr } from '../methods';

import { api } from '../api';
import LoadingProgress from './LoadingProgress';
import { Add } from '@mui/icons-material';

const Notifications = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get(`/notifications`)
      .then((res) => setNotifications(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const handleSendNotification = () => {
    navigate('/notifications/send-notification');
  };

  if (loading) return <LoadingProgress />;

  return (
    <Box p={2}>
      {/* Header with Add Button */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">Notifications</Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handleSendNotification}
        >
          Send Notification
        </Button>
      </Box>

      {/* List of notifications (1 per row) */}
      <Box display="flex" flexDirection="column" gap={2}>
        {notifications.map((n) => (
          <Card
            key={n.id}
            onClick={() => navigate(`/notifications/${n.id}`)}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.01)',
                boxShadow: 3,
              },
            }}
          >
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {n.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom noWrap>
                {n.message}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Sent at: {formatDateTimeFr(n.sent_at)}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default Notifications;
